import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { Search } from 'lucide-react';

interface ContextSearchProps {
  searchTerm: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ContextSearch = ({
  searchTerm,
  handleChange,
}: ContextSearchProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <TextField
        fullWidth
        size='small'
        placeholder='Search by title, topic, uploader...'
        value={searchTerm}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search size={18} color='#94a3b8' />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            fontSize: '0.875rem',
            '& fieldset': {
              borderColor: '#e2e8f0',
            },
            '&:hover fieldset': {
              borderColor: '#cbd5e1',
            },
            '&.Mui-focused': {
              backgroundColor: '#ffffff',
              '& fieldset': {
                borderColor: '#10b981',
              },
            },
          },
        }}
      />
    </Box>
  );
};
